
export default {
    name: 'rapport-ecart-caisse',
    components: {},
    props: {
        rapport_ecarts_caisse: Array,
        modal_toggler: Number,
        by_type_ecart: String
    },
    data () {
        return {
            fields: [
                { key: 'no', label: 'N°' },
                { key: 'ref', label: 'Référence' }, "date", { key: 'user', label: 'Caissier(e)' },
                { key: 'libelle', label: 'Libellé' }, { key: 'solde_au_versement', label: 'Solde au versement' },
                { key: 'montant_verse', label: 'Montant versé' }, { key: 'ecart_caisse', label: 'Ecart caisse' }
            ],
           
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            total_pages: 0,
            ecart_len: 0,
        }
    },

    watch: {
        modal_toggler() {
            this.refreshEcartCaisse()
            this.filter = this.by_type_ecart
        }
    },

    computed: {

    },

    mounted () {

    },

    methods: {
        refreshEcartCaisse() {
            if (this.rapport_ecarts_caisse) {
                this.ecart_len = this.rapport_ecarts_caisse.length
            }
        }
    }
}